import React from 'react';

const FadeInSection = ({ children }) => <>{children}</>;

export default FadeInSection;
